module.exports = __webpack_public_path__ + "media/icons/gallery-next-d60f2f22.png";